import { STOREFRONT_TRANSLATIONS } from "./storefrontTranslations";
// Simple i18n dictionary for 5 languages.
export const LANGUAGES = [
    { code: "en", label: "English", short: "EN" },
    { code: "de", label: "Deutsch", short: "DE" },
    { code: "fr", label: "Français", short: "FR" },
    { code: "es", label: "Español", short: "ES" },
    { code: "it", label: "Italiano", short: "IT" },
];

const BASE_TRANSLATIONS = {
    en: {
        "nav.home": "Home",
        "nav.masalas": "Indian Spices",
        "nav.decor": "Home Furnishing",
        "nav.jewelry": "Artificial Jewelry",
        "nav.christmas": "Christmas Decor",
        "nav.shop": "Shop",
        "nav.account": "Account",
        "nav.login": "Sign In",
        "nav.logout": "Sign Out",
        "nav.register": "Register",
        "nav.cart": "Cart",
        "nav.admin": "Admin",
        "hero.eyebrow": "Est. India · Exporting to Europe",
        "hero.title": "The world's most quiet luxuries.",
        "hero.subtitle": "Small-batch Indian spices, handcrafted home textiles and artisan jewelry — shipped from Delhi to your table.",
        "hero.cta": "Explore the collection",
        "hero.cta2": "Discover our story",
        "sec.about.eyebrow": "— Our Story",
        "sec.about.title": "From a Noida atelier to European homes.",
        "sec.about.p1": "Keneth Global Inc began as a family pursuit — sourcing the finest of India's spice gardens, handlooms and artisan workshops, and carrying them, unhurried, to Europe.",
        "sec.about.p2": "We work directly with growers and makers across six Indian states. No factories, no middlemen — only small batches, fair partnerships and pieces made to be lived with.",
        "sec.about.cta": "Read our full story",
        "sec.verticals.title": "Three houses. One provenance.",
        "sec.verticals.sub": "Every piece begins in a small workshop or family kitchen — never a factory.",
        "vert.masalas.title": "The Spice House",
        "vert.masalas.desc": "Hand-roasted, stone-ground, sealed within hours.",
        "vert.decor.title": "Home Furnishing",
        "vert.decor.desc": "Block-printed and hand-embroidered textiles from six Indian states.",
        "vert.jewelry.title": "Artificial Jewelry",
        "vert.jewelry.desc": "Handcrafted artisan jewelry — kundan, meenakari, temple gold.",
        "vert.christmas.title": "Christmas Decor",
        "vert.christmas.desc": "Festive handcrafted ornaments, textiles and table settings — arriving this season.",
        "sec.comingSoon": "Coming soon",
        "sec.category.viewAll": "View all",
        "sec.featured.title": "Featured this season",
        "sec.featured.sub": "A curated shortlist from all three houses.",
        "sec.craft.title": "The unhurried way",
        "sec.craft.p1": "Nothing in our workshops is measured in minutes. Our garam masala is roasted for forty-five days a year, only. Our Banarasi silks pass through fourteen pairs of hands before they leave the loom.",
        "sec.craft.p2": "The result is a catalogue of ninety-one products across three verticals — small enough for us to know every maker, generous enough for you to build a home.",
        "sec.press.title": "As encountered in",
        "sec.newsletter.title": "The dispatch.",
        "sec.newsletter.sub": "Seasonal notes, new arrivals, and the occasional recipe. Never more than twice a month.",
        "sec.newsletter.placeholder": "Your email",
        "sec.newsletter.submit": "Subscribe",
        "shop.title": "The shop",
        "shop.filter.all": "All",
        "shop.filter.masalas": "Indian Spices",
        "shop.filter.decor": "Home Furnishing",
        "shop.filter.jewelry": "Artificial Jewelry",
        "shop.filter.christmas": "Christmas Decor",
        "shop.empty": "No products match your filter.",
        "shop.soon": "This collection is arriving soon. Check back shortly.",
        "prod.addCart": "Add to cart",
        "prod.buyNow": "Buy now",
        "prod.details": "Details",
        "prod.qty": "Quantity",
        "prod.related": "You may also like",
        "cart.title": "Your cart",
        "cart.empty": "Your cart is quiet. Start browsing to fill it.",
        "cart.item": "Item",
        "cart.qty": "Qty",
        "cart.price": "Price",
        "cart.total": "Total",
        "cart.subtotal": "Subtotal",
        "cart.checkout": "Proceed to checkout",
        "cart.continue": "Continue shopping",
        "cart.remove": "Remove",
        "checkout.processing": "Preparing your checkout…",
        "success.title": "Thank you.",
        "success.sub": "Your order has been received. A confirmation will arrive by email.",
        "success.orderId": "Order reference",
        "success.viewOrders": "View my orders",
        "cancel.title": "Payment cancelled",
        "cancel.sub": "No charge was made. You can return to your cart at any time.",
        "cancel.back": "Back to cart",
        "auth.login.title": "Welcome back",
        "auth.login.sub": "Sign in to view orders and check out faster.",
        "auth.register.title": "Create an account",
        "auth.register.sub": "For a more personal correspondence.",
        "auth.email": "Email",
        "auth.password": "Password",
        "auth.name": "Full name",
        "auth.signIn": "Sign in",
        "auth.signUp": "Create account",
        "auth.noAccount": "Don't have an account?",
        "auth.hasAccount": "Already have an account?",
        "acct.title": "Your orders",
        "acct.sub": "A record of every dispatch from Keneth Global.",
        "acct.empty": "No orders yet.",
        "acct.orderId": "Order",
        "acct.date": "Placed on",
        "acct.status": "Status",
        "acct.amount": "Amount",
        "acct.items": "Items",
        "admin.title": "Atelier — admin",
        "admin.stats": "At a glance",
        "admin.products": "Products",
        "admin.orders": "Orders",
        "admin.users": "Customers",
        "admin.revenue": "Revenue",
        "footer.about": "House",
        "footer.about.about": "About Us",
        "footer.about.craft": "Craftsmanship",
        "footer.about.press": "Press",
        "footer.shop": "Shop",
        "footer.support": "Client care",
        "footer.support.contact": "Contact",
        "footer.support.shipping": "Shipping",
        "footer.support.returns": "Returns",
        "footer.legal": "© 2026 Keneth Global Inc. All rights reserved.",
        "footer.tagline": "Shop the world anytime, anywhere.",
        "common.loading": "Loading…",
        "badge.new": "New",
        "home.about.eyebrow": "About Keneth Global",
        "home.about.title": "A house of Indian craft, shipped to your table.",
        "home.about.p1": "Founded in Noida in 2023, Keneth Global is a family-run export house bringing India's finest small-batch spices, hand-loomed textiles and artisan jewelry to homes across Europe — without the middlemen who dull both quality and story.",
        "home.about.p2": "Every masala is sealed within hours of milling. Every textile is block-printed and embroidered by workshops we know by name. Every piece of jewelry is finished by hand. We are a fully registered DGFT exporter, FSSAI-compliant and GST-verified.",
        "home.about.cta": "Read our story",
        "home.about.stat.products": "Curated products",
        "home.about.stat.houses": "Artisan houses",
        "home.about.stat.est": "Established, Noida",
        "home.house.masalas": "The Spice House",
        "home.house.artificial-jewelry": "The Jewel House",
        "home.house.home-furnishing": "The Fabric House",
        "home.house.christmas-decor": "The Season House",
        "home.shopAll": "Shop all →",
        "home.viewAll": "View all →",
        "home.testi.eyebrow": "Loved across Europe",
        "home.testi.title": "What our patrons say",
        "home.testi.q1": "The garam masala smells like it was ground this morning — because it practically was. Nothing on my shelf comes close.",
        "home.testi.q2": "Our Banarasi table runner draws a comment at every dinner. The craftsmanship is genuinely museum-grade.",
        "home.testi.q3": "The kundan choker arrived beautifully boxed and looks far more expensive than it was. My go-to for gifting.",
        "cart.giftwrap.title": "Add premium gift wrap",
        "cart.giftwrap.desc": "Hand-wrapped in mulberry paper with a gold wax seal and dried botanicals.",
        "cart.giftwrap.note": "Gift message (optional)",
        "cart.giftwrap.notePlaceholder": "Write a short handwritten note…",
        "cart.giftwrap.line": "Gift wrap",
        "xmas.banner": "Complimentary express delivery on Christmas orders over €90 — ends 24 December",
        "xmas.eyebrow": "The Festive Edit",
        "xmas.title": "A very handcrafted Christmas.",
        "xmas.subtitle": "Limited-run ornaments, embroidered stockings and festive table linens — made by hand in India, wrapped and shipped across Europe in time for the tree.",
        "xmas.cta": "Shop the collection",
        "xmas.guide.title": "The gift guide",
        "xmas.guide.sub": "Chosen by our atelier — for every name on your list.",
        "xmas.guide.under": "Under €30",
        "xmas.guide.statement": "Statement gifts",
        "xmas.guide.forHome": "For the host",
        "xmas.shopAll": "Shop all Christmas →",
        "xmas.count.days": "days until Christmas",
        "xmas.count.today": "Merry Christmas!",
        "xmas.count.orderby": "Order by {d} for delivery in time",
        "b2b.button": "Business / bulk order",
        "b2b.title": "Request a bulk / trade order",
        "b2b.sub": "For wholesale and business orders. Leave your details and our export desk will call you back with trade pricing.",
        "b2b.name": "Your name",
        "b2b.phone": "Contact number",
        "b2b.qty": "Quantity / units required",
        "b2b.email": "Email (optional)",
        "b2b.message": "Message (optional)",
        "b2b.submit": "Request callback",
        "b2b.sending": "Sending…",
        "b2b.success": "Request received — our team will contact you shortly.",
    },
    de: {
        "nav.home": "Startseite",
        "nav.masalas": "Indische Gewürze",
        "nav.decor": "Wohnausstattung",
        "nav.jewelry": "Modeschmuck",
        "nav.christmas": "Weihnachtsdeko",
        "nav.shop": "Shop",
        "nav.account": "Konto",
        "nav.login": "Anmelden",
        "nav.logout": "Abmelden",
        "nav.register": "Registrieren",
        "nav.cart": "Warenkorb",
        "nav.admin": "Admin",
        "hero.eyebrow": "Gegr. Indien · Export nach Europa",
        "hero.title": "Die stillsten Luxusgüter der Welt.",
        "hero.subtitle": "Handgeröstete indische Gewürze, handgefertigte Textilien und Kunsthandwerk-Schmuck — direkt aus Delhi.",
        "hero.cta": "Kollektion entdecken",
        "hero.cta2": "Unsere Geschichte",
        "sec.about.eyebrow": "— Unsere Geschichte",
        "sec.about.title": "Von einem Atelier in Noida in europäische Häuser.",
        "sec.about.p1": "Keneth Global Inc begann als Familienunternehmen — auf der Suche nach dem Feinsten aus Indiens Gewürzgärten, Handwebereien und Kunsthandwerksateliers, um es unaufgeregt nach Europa zu bringen.",
        "sec.about.p2": "Wir arbeiten direkt mit Erzeugern und Handwerkern in sechs indischen Bundesstaaten. Keine Fabriken, keine Zwischenhändler — nur kleine Chargen und faire Partnerschaften.",
        "sec.about.cta": "Ganze Geschichte lesen",
        "sec.verticals.title": "Drei Häuser. Ein Ursprung.",
        "sec.verticals.sub": "Jedes Stück beginnt in einer kleinen Werkstatt oder Familienküche — niemals in einer Fabrik.",
        "vert.masalas.title": "Das Gewürzhaus",
        "vert.masalas.desc": "Handgeröstet, steingemahlen, innerhalb weniger Stunden versiegelt.",
        "vert.decor.title": "Wohnausstattung",
        "vert.decor.desc": "Blockgedruckte und handbestickte Textilien aus sechs indischen Staaten.",
        "vert.jewelry.title": "Modeschmuck",
        "vert.jewelry.desc": "Handgefertigter Kunsthandwerk-Schmuck — Kundan, Meenakari, Tempelgold.",
        "vert.christmas.title": "Weihnachtsdeko",
        "vert.christmas.desc": "Festliche handgefertigte Ornamente, Textilien und Tischdekorationen — in dieser Saison erhältlich.",
        "sec.comingSoon": "Demnächst",
        "sec.category.viewAll": "Alle ansehen",
        "sec.featured.title": "Diese Saison im Blickpunkt",
        "sec.featured.sub": "Eine kuratierte Auswahl aus allen drei Häusern.",
        "sec.craft.title": "Der unaufgeregte Weg",
        "sec.craft.p1": "Nichts in unseren Werkstätten wird in Minuten gemessen. Unser Garam Masala wird nur fünfundvierzig Tage im Jahr geröstet.",
        "sec.craft.p2": "Das Ergebnis ist ein Katalog von einundneunzig Produkten in drei Bereichen.",
        "sec.press.title": "Erwähnt in",
        "sec.newsletter.title": "Die Depesche.",
        "sec.newsletter.sub": "Saisonale Notizen und Neuheiten. Nie öfter als zweimal im Monat.",
        "sec.newsletter.placeholder": "Ihre E-Mail",
        "sec.newsletter.submit": "Abonnieren",
        "shop.title": "Der Shop",
        "shop.filter.all": "Alle",
        "shop.filter.masalas": "Indische Gewürze",
        "shop.filter.decor": "Wohnausstattung",
        "shop.filter.jewelry": "Modeschmuck",
        "shop.filter.christmas": "Weihnachtsdeko",
        "shop.empty": "Keine Produkte gefunden.",
        "shop.soon": "Diese Kollektion erscheint bald. Schauen Sie in Kürze wieder vorbei.",
        "prod.addCart": "In den Warenkorb",
        "prod.buyNow": "Jetzt kaufen",
        "prod.details": "Details",
        "prod.qty": "Menge",
        "prod.related": "Vielleicht auch interessant",
        "cart.title": "Ihr Warenkorb",
        "cart.empty": "Ihr Warenkorb ist leer.",
        "cart.item": "Artikel",
        "cart.qty": "Anz.",
        "cart.price": "Preis",
        "cart.total": "Gesamt",
        "cart.subtotal": "Zwischensumme",
        "cart.checkout": "Zur Kasse",
        "cart.continue": "Weiter einkaufen",
        "cart.remove": "Entfernen",
        "checkout.processing": "Ihre Bestellung wird vorbereitet…",
        "success.title": "Vielen Dank.",
        "success.sub": "Ihre Bestellung wurde entgegengenommen.",
        "success.orderId": "Bestellreferenz",
        "success.viewOrders": "Meine Bestellungen",
        "cancel.title": "Zahlung abgebrochen",
        "cancel.sub": "Es wurde keine Belastung vorgenommen.",
        "cancel.back": "Zurück zum Warenkorb",
        "auth.login.title": "Willkommen zurück",
        "auth.login.sub": "Melden Sie sich an.",
        "auth.register.title": "Konto erstellen",
        "auth.register.sub": "Für eine persönlichere Korrespondenz.",
        "auth.email": "E-Mail",
        "auth.password": "Passwort",
        "auth.name": "Vollständiger Name",
        "auth.signIn": "Anmelden",
        "auth.signUp": "Konto erstellen",
        "auth.noAccount": "Noch kein Konto?",
        "auth.hasAccount": "Bereits ein Konto?",
        "acct.title": "Ihre Bestellungen",
        "acct.sub": "Eine Aufzeichnung jeder Sendung.",
        "acct.empty": "Noch keine Bestellungen.",
        "acct.orderId": "Bestellung",
        "acct.date": "Bestellt am",
        "acct.status": "Status",
        "acct.amount": "Betrag",
        "acct.items": "Artikel",
        "admin.title": "Atelier — Admin",
        "admin.stats": "Auf einen Blick",
        "admin.products": "Produkte",
        "admin.orders": "Bestellungen",
        "admin.users": "Kunden",
        "admin.revenue": "Umsatz",
        "footer.about": "Haus",
        "footer.about.about": "Über uns",
        "footer.about.craft": "Handwerkskunst",
        "footer.about.press": "Presse",
        "footer.shop": "Shop",
        "footer.support": "Kundenservice",
        "footer.support.contact": "Kontakt",
        "footer.support.shipping": "Versand",
        "footer.support.returns": "Rücksendungen",
        "footer.legal": "© 2026 Keneth Global Inc. Alle Rechte vorbehalten.",
        "footer.tagline": "Shoppen Sie die Welt, jederzeit, überall.",
        "common.loading": "Lädt…",
        "badge.new": "Neu",
        "home.about.eyebrow": "Über Keneth Global",
        "home.about.title": "Ein Haus indischen Handwerks, direkt auf Ihren Tisch.",
        "home.about.p1": "Gegründet 2023 in Noida, ist Keneth Global ein familiengeführtes Exporthaus, das Indiens feinste Gewürze in kleinen Chargen, handgewebte Textilien und Kunsthandwerk-Schmuck in Häuser in ganz Europa bringt — ohne Zwischenhändler, die Qualität und Geschichte verwässern.",
        "home.about.p2": "Jedes Masala wird innerhalb weniger Stunden nach dem Mahlen versiegelt. Jedes Textil wird von Werkstätten bedruckt und bestickt, die wir beim Namen kennen. Jedes Schmuckstück wird von Hand vollendet. Wir sind ein registrierter DGFT-Exporteur, FSSAI-konform und GST-geprüft.",
        "home.about.cta": "Unsere Geschichte lesen",
        "home.about.stat.products": "Kuratierte Produkte",
        "home.about.stat.houses": "Handwerkshäuser",
        "home.about.stat.est": "Gegründet, Noida",
        "home.house.masalas": "Das Gewürzhaus",
        "home.house.artificial-jewelry": "Das Schmuckhaus",
        "home.house.home-furnishing": "Das Textilhaus",
        "home.house.christmas-decor": "Das Saisonhaus",
        "home.shopAll": "Alle ansehen →",
        "home.viewAll": "Alle ansehen →",
        "home.testi.eyebrow": "In ganz Europa geliebt",
        "home.testi.title": "Was unsere Kunden sagen",
        "home.testi.q1": "Das Garam Masala duftet, als wäre es heute Morgen gemahlen worden — praktisch war es das. Nichts in meinem Regal kommt da heran.",
        "home.testi.q2": "Unser Banarasi-Tischläufer wird bei jedem Dinner bewundert. Die Handwerkskunst ist wirklich museumsreif.",
        "home.testi.q3": "Das Kundan-Collier kam wunderschön verpackt an und wirkt weit teurer, als es war. Mein Favorit zum Verschenken.",
        "cart.giftwrap.title": "Premium-Geschenkverpackung hinzufügen",
        "cart.giftwrap.desc": "Von Hand in Maulbeerpapier gewickelt, mit goldenem Wachssiegel und getrockneten Blüten.",
        "cart.giftwrap.note": "Geschenknachricht (optional)",
        "cart.giftwrap.notePlaceholder": "Schreiben Sie eine kurze handschriftliche Notiz…",
        "cart.giftwrap.line": "Geschenkverpackung",
        "xmas.banner": "Kostenlose Express-Lieferung für Weihnachtsbestellungen über 90 € — bis 24. Dezember",
        "xmas.eyebrow": "Die festliche Auswahl",
        "xmas.title": "Ein sehr handgemachtes Weihnachten.",
        "xmas.subtitle": "Ornamente in limitierter Auflage, bestickte Strümpfe und festliche Tischwäsche — von Hand in Indien gefertigt, verpackt und rechtzeitig zum Fest in ganz Europa verschickt.",
        "xmas.cta": "Kollektion ansehen",
        "xmas.guide.title": "Der Geschenkeführer",
        "xmas.guide.sub": "Von unserem Atelier ausgewählt — für jeden auf Ihrer Liste.",
        "xmas.guide.under": "Unter 30 €",
        "xmas.guide.statement": "Besondere Geschenke",
        "xmas.guide.forHome": "Für die Gastgeber",
        "xmas.shopAll": "Alle Weihnachtsartikel →",
        "xmas.count.days": "Tage bis Weihnachten",
        "xmas.count.today": "Frohe Weihnachten!",
        "xmas.count.orderby": "Bis {d} bestellen für rechtzeitige Lieferung",
        "b2b.button": "Geschäft / Großbestellung",
        "b2b.title": "Groß- / Handelsbestellung anfragen",
        "b2b.sub": "Für Großhandels- und Geschäftsbestellungen. Hinterlassen Sie Ihre Daten, unser Export-Team ruft Sie mit Handelspreisen zurück.",
        "b2b.name": "Ihr Name",
        "b2b.phone": "Telefonnummer",
        "b2b.qty": "Benötigte Menge / Einheiten",
        "b2b.email": "E-Mail (optional)",
        "b2b.message": "Nachricht (optional)",
        "b2b.submit": "Rückruf anfordern",
        "b2b.sending": "Wird gesendet…",
        "b2b.success": "Anfrage erhalten — unser Team meldet sich in Kürze.",
    },
    fr: {
        "nav.home": "Accueil",
        "nav.masalas": "Épices Indiennes",
        "nav.decor": "Ameublement",
        "nav.jewelry": "Bijoux Fantaisie",
        "nav.christmas": "Déco de Noël",
        "nav.shop": "Boutique",
        "nav.account": "Compte",
        "nav.login": "Se connecter",
        "nav.logout": "Déconnexion",
        "nav.register": "S'inscrire",
        "nav.cart": "Panier",
        "nav.admin": "Admin",
        "hero.eyebrow": "Fondé en Inde · Export vers l'Europe",
        "hero.title": "Les luxes les plus discrets du monde.",
        "hero.subtitle": "Épices indiennes en petits lots, textiles d'intérieur artisanaux et bijoux d'artisan — expédiés de Delhi à votre table.",
        "hero.cta": "Explorer la collection",
        "hero.cta2": "Notre histoire",
        "sec.about.eyebrow": "— Notre Histoire",
        "sec.about.title": "D'un atelier de Noida aux foyers européens.",
        "sec.about.p1": "Keneth Global Inc a débuté comme une aventure familiale — sourcer le meilleur des jardins d'épices, des métiers à tisser et des ateliers d'artisans d'Inde, pour l'amener sans hâte en Europe.",
        "sec.about.p2": "Nous travaillons directement avec les producteurs et artisans de six États indiens. Pas d'usines, pas d'intermédiaires — seulement de petits lots et des partenariats équitables.",
        "sec.about.cta": "Lire notre histoire",
        "sec.verticals.title": "Trois maisons. Une origine.",
        "sec.verticals.sub": "Chaque pièce naît dans un petit atelier ou une cuisine familiale — jamais dans une usine.",
        "vert.masalas.title": "La Maison des Épices",
        "vert.masalas.desc": "Torréfiées à la main, broyées à la pierre, scellées en quelques heures.",
        "vert.decor.title": "Ameublement",
        "vert.decor.desc": "Textiles imprimés au bloc et brodés à la main, issus de six États indiens.",
        "vert.jewelry.title": "Bijoux Fantaisie",
        "vert.jewelry.desc": "Bijoux d'artisan faits main — kundan, meenakari, or de temple.",
        "vert.christmas.title": "Déco de Noël",
        "vert.christmas.desc": "Ornements, textiles et arts de la table festifs faits main — bientôt disponibles.",
        "sec.comingSoon": "Bientôt disponible",
        "sec.category.viewAll": "Tout voir",
        "sec.featured.title": "En vedette cette saison",
        "sec.featured.sub": "Une sélection des trois maisons.",
        "sec.craft.title": "La voie lente",
        "sec.craft.p1": "Rien dans nos ateliers ne se mesure en minutes.",
        "sec.craft.p2": "Le résultat : un catalogue de quatre-vingt-onze produits en trois univers.",
        "sec.press.title": "Repéré dans",
        "sec.newsletter.title": "La dépêche.",
        "sec.newsletter.sub": "Notes saisonnières et nouveautés. Deux fois par mois maximum.",
        "sec.newsletter.placeholder": "Votre email",
        "sec.newsletter.submit": "S'abonner",
        "shop.title": "La boutique",
        "shop.filter.all": "Tout",
        "shop.filter.masalas": "Épices Indiennes",
        "shop.filter.decor": "Ameublement",
        "shop.filter.jewelry": "Bijoux Fantaisie",
        "shop.filter.christmas": "Déco de Noël",
        "shop.empty": "Aucun produit ne correspond à votre filtre.",
        "shop.soon": "Cette collection arrive bientôt. Revenez sous peu.",
        "prod.addCart": "Ajouter au panier",
        "prod.buyNow": "Acheter",
        "prod.details": "Détails",
        "prod.qty": "Quantité",
        "prod.related": "Vous pourriez aimer",
        "cart.title": "Votre panier",
        "cart.empty": "Votre panier est vide.",
        "cart.item": "Article",
        "cart.qty": "Qté",
        "cart.price": "Prix",
        "cart.total": "Total",
        "cart.subtotal": "Sous-total",
        "cart.checkout": "Passer à la caisse",
        "cart.continue": "Continuer les achats",
        "cart.remove": "Retirer",
        "checkout.processing": "Préparation…",
        "success.title": "Merci.",
        "success.sub": "Votre commande a été reçue.",
        "success.orderId": "Référence",
        "success.viewOrders": "Voir mes commandes",
        "cancel.title": "Paiement annulé",
        "cancel.sub": "Aucun débit n'a été effectué.",
        "cancel.back": "Retour au panier",
        "auth.login.title": "Ravi de vous revoir",
        "auth.login.sub": "Connectez-vous.",
        "auth.register.title": "Créer un compte",
        "auth.register.sub": "Pour une correspondance plus personnelle.",
        "auth.email": "Email",
        "auth.password": "Mot de passe",
        "auth.name": "Nom complet",
        "auth.signIn": "Se connecter",
        "auth.signUp": "Créer",
        "auth.noAccount": "Pas de compte ?",
        "auth.hasAccount": "Déjà un compte ?",
        "acct.title": "Vos commandes",
        "acct.sub": "Toutes vos expéditions.",
        "acct.empty": "Aucune commande.",
        "acct.orderId": "Commande",
        "acct.date": "Le",
        "acct.status": "Statut",
        "acct.amount": "Montant",
        "acct.items": "Articles",
        "admin.title": "Atelier — admin",
        "admin.stats": "Vue d'ensemble",
        "admin.products": "Produits",
        "admin.orders": "Commandes",
        "admin.users": "Clients",
        "admin.revenue": "Revenus",
        "footer.about": "Maison",
        "footer.about.about": "À propos",
        "footer.about.craft": "Artisanat",
        "footer.about.press": "Presse",
        "footer.shop": "Boutique",
        "footer.support": "Service client",
        "footer.support.contact": "Contact",
        "footer.support.shipping": "Expédition",
        "footer.support.returns": "Retours",
        "footer.legal": "© 2026 Keneth Global Inc. Tous droits réservés.",
        "footer.tagline": "Le monde à portée de clic, à tout moment.",
        "common.loading": "Chargement…",
        "badge.new": "Nouveau",
        "home.about.eyebrow": "À propos de Keneth Global",
        "home.about.title": "Une maison d'artisanat indien, livrée à votre table.",
        "home.about.p1": "Fondée à Noida en 2023, Keneth Global est une maison d'export familiale qui apporte les meilleures épices indiennes en petits lots, les textiles tissés main et les bijoux d'artisan aux foyers de toute l'Europe — sans les intermédiaires qui appauvrissent la qualité et l'histoire.",
        "home.about.p2": "Chaque masala est scellé quelques heures après la mouture. Chaque textile est imprimé et brodé par des ateliers que nous connaissons par leur nom. Chaque bijou est fini à la main. Nous sommes un exportateur DGFT enregistré, conforme FSSAI et vérifié GST.",
        "home.about.cta": "Lire notre histoire",
        "home.about.stat.products": "Produits sélectionnés",
        "home.about.stat.houses": "Maisons d'artisans",
        "home.about.stat.est": "Fondée, Noida",
        "home.house.masalas": "La Maison des Épices",
        "home.house.artificial-jewelry": "La Maison du Bijou",
        "home.house.home-furnishing": "La Maison du Textile",
        "home.house.christmas-decor": "La Maison de la Saison",
        "home.shopAll": "Tout voir →",
        "home.viewAll": "Tout voir →",
        "home.testi.eyebrow": "Adoré dans toute l'Europe",
        "home.testi.title": "Ce que disent nos clients",
        "home.testi.q1": "Le garam masala sent comme s'il avait été moulu ce matin — c'est presque le cas. Rien sur mon étagère ne s'en approche.",
        "home.testi.q2": "Notre chemin de table Banarasi suscite un commentaire à chaque dîner. Le travail est véritablement digne d'un musée.",
        "home.testi.q3": "Le collier kundan est arrivé magnifiquement emballé et paraît bien plus cher qu'il ne l'était. Mon incontournable pour offrir.",
        "cart.giftwrap.title": "Ajouter un emballage cadeau premium",
        "cart.giftwrap.desc": "Emballé à la main dans du papier mûrier, avec sceau de cire doré et fleurs séchées.",
        "cart.giftwrap.note": "Message cadeau (facultatif)",
        "cart.giftwrap.notePlaceholder": "Écrivez un petit mot manuscrit…",
        "cart.giftwrap.line": "Emballage cadeau",
        "xmas.banner": "Livraison express offerte pour les commandes de Noël de plus de 90 € — jusqu'au 24 décembre",
        "xmas.eyebrow": "La Sélection Festive",
        "xmas.title": "Un Noël très artisanal.",
        "xmas.subtitle": "Ornements en édition limitée, bas brodés et linge de table festif — faits main en Inde, emballés et expédiés dans toute l'Europe à temps pour le sapin.",
        "xmas.cta": "Découvrir la collection",
        "xmas.guide.title": "Le guide cadeaux",
        "xmas.guide.sub": "Choisis par notre atelier — pour chaque nom de votre liste.",
        "xmas.guide.under": "Moins de 30 €",
        "xmas.guide.statement": "Cadeaux d'exception",
        "xmas.guide.forHome": "Pour l'hôte",
        "xmas.shopAll": "Tout voir Noël →",
        "xmas.count.days": "jours avant Noël",
        "xmas.count.today": "Joyeux Noël !",
        "xmas.count.orderby": "Commandez avant le {d} pour une livraison à temps",
        "b2b.button": "Professionnel / commande en gros",
        "b2b.title": "Demander une commande en gros / professionnelle",
        "b2b.sub": "Pour les commandes en gros et professionnelles. Laissez vos coordonnées, notre service export vous rappellera avec des tarifs professionnels.",
        "b2b.name": "Votre nom",
        "b2b.phone": "Numéro de téléphone",
        "b2b.qty": "Quantité / unités requises",
        "b2b.email": "Email (facultatif)",
        "b2b.message": "Message (facultatif)",
        "b2b.submit": "Demander un rappel",
        "b2b.sending": "Envoi…",
        "b2b.success": "Demande reçue — notre équipe vous contactera sous peu.",
    },
    es: {
        "nav.home": "Inicio",
        "nav.masalas": "Especias Indias",
        "nav.decor": "Menaje del Hogar",
        "nav.jewelry": "Bisutería",
        "nav.christmas": "Decoración Navideña",
        "nav.shop": "Tienda",
        "nav.account": "Cuenta",
        "nav.login": "Iniciar sesión",
        "nav.logout": "Salir",
        "nav.register": "Registrarse",
        "nav.cart": "Cesta",
        "nav.admin": "Admin",
        "hero.eyebrow": "Fund. India · Exportación a Europa",
        "hero.title": "Los lujos más silenciosos del mundo.",
        "hero.subtitle": "Especias indias de pequeños lotes, textiles artesanales y joyería artesanal — enviados desde Delhi.",
        "hero.cta": "Explorar la colección",
        "hero.cta2": "Nuestra historia",
        "sec.about.eyebrow": "— Nuestra Historia",
        "sec.about.title": "De un taller en Noida a los hogares europeos.",
        "sec.about.p1": "Keneth Global Inc nació como un proyecto familiar — buscar lo mejor de los jardines de especias, telares y talleres artesanales de la India, y llevarlo, sin prisa, a Europa.",
        "sec.about.p2": "Trabajamos directamente con productores y artesanos de seis estados de la India. Sin fábricas, sin intermediarios — solo pequeños lotes y relaciones justas.",
        "sec.about.cta": "Leer nuestra historia",
        "sec.verticals.title": "Tres casas. Un origen.",
        "sec.verticals.sub": "Cada pieza nace en un pequeño taller o cocina familiar.",
        "vert.masalas.title": "La Casa de las Especias",
        "vert.masalas.desc": "Tostadas a mano, molidas a piedra, selladas en horas.",
        "vert.decor.title": "Menaje del Hogar",
        "vert.decor.desc": "Textiles estampados y bordados a mano.",
        "vert.jewelry.title": "Bisutería",
        "vert.jewelry.desc": "Joyería artesanal hecha a mano — kundan, meenakari, oro del templo.",
        "vert.christmas.title": "Decoración Navideña",
        "vert.christmas.desc": "Adornos, textiles y mesas festivas hechos a mano — llegan esta temporada.",
        "sec.comingSoon": "Próximamente",
        "sec.category.viewAll": "Ver todo",
        "sec.featured.title": "Destacados esta temporada",
        "sec.featured.sub": "Una selección de las tres casas.",
        "sec.craft.title": "El camino sin prisa",
        "sec.craft.p1": "Nada en nuestros talleres se mide en minutos.",
        "sec.craft.p2": "El resultado: un catálogo de noventa y un productos.",
        "sec.press.title": "Visto en",
        "sec.newsletter.title": "El despacho.",
        "sec.newsletter.sub": "Notas de temporada. Nunca más de dos veces al mes.",
        "sec.newsletter.placeholder": "Su correo",
        "sec.newsletter.submit": "Suscribirse",
        "shop.title": "La tienda",
        "shop.filter.all": "Todo",
        "shop.filter.masalas": "Especias Indias",
        "shop.filter.decor": "Menaje del Hogar",
        "shop.filter.jewelry": "Bisutería",
        "shop.filter.christmas": "Decoración Navideña",
        "shop.empty": "Ningún producto coincide.",
        "shop.soon": "Esta colección llega pronto. Vuelva en breve.",
        "prod.addCart": "Añadir a la cesta",
        "prod.buyNow": "Comprar",
        "prod.details": "Detalles",
        "prod.qty": "Cantidad",
        "prod.related": "También podría gustarle",
        "cart.title": "Su cesta",
        "cart.empty": "Su cesta está vacía.",
        "cart.item": "Artículo",
        "cart.qty": "Cant.",
        "cart.price": "Precio",
        "cart.total": "Total",
        "cart.subtotal": "Subtotal",
        "cart.checkout": "Ir a la caja",
        "cart.continue": "Seguir comprando",
        "cart.remove": "Eliminar",
        "checkout.processing": "Preparando…",
        "success.title": "Gracias.",
        "success.sub": "Su pedido ha sido recibido.",
        "success.orderId": "Referencia",
        "success.viewOrders": "Mis pedidos",
        "cancel.title": "Pago cancelado",
        "cancel.sub": "No se realizó ningún cargo.",
        "cancel.back": "Volver a la cesta",
        "auth.login.title": "Bienvenido de nuevo",
        "auth.login.sub": "Inicie sesión.",
        "auth.register.title": "Crear cuenta",
        "auth.register.sub": "Para una correspondencia más personal.",
        "auth.email": "Correo",
        "auth.password": "Contraseña",
        "auth.name": "Nombre completo",
        "auth.signIn": "Entrar",
        "auth.signUp": "Crear",
        "auth.noAccount": "¿No tiene cuenta?",
        "auth.hasAccount": "¿Ya tiene cuenta?",
        "acct.title": "Sus pedidos",
        "acct.sub": "Registro de cada envío.",
        "acct.empty": "Sin pedidos.",
        "acct.orderId": "Pedido",
        "acct.date": "Realizado el",
        "acct.status": "Estado",
        "acct.amount": "Importe",
        "acct.items": "Artículos",
        "admin.title": "Atelier — admin",
        "admin.stats": "Resumen",
        "admin.products": "Productos",
        "admin.orders": "Pedidos",
        "admin.users": "Clientes",
        "admin.revenue": "Ingresos",
        "footer.about": "Casa",
        "footer.about.about": "Sobre nosotros",
        "footer.about.craft": "Artesanía",
        "footer.about.press": "Prensa",
        "footer.shop": "Tienda",
        "footer.support": "Atención",
        "footer.support.contact": "Contacto",
        "footer.support.shipping": "Envíos",
        "footer.support.returns": "Devoluciones",
        "footer.legal": "© 2026 Keneth Global Inc. Todos los derechos reservados.",
        "footer.tagline": "Compre el mundo, en cualquier momento.",
        "common.loading": "Cargando…",
        "badge.new": "Nuevo",
        "home.about.eyebrow": "Sobre Keneth Global",
        "home.about.title": "Una casa de artesanía india, enviada a su mesa.",
        "home.about.p1": "Fundada en Noida en 2023, Keneth Global es una casa exportadora familiar que lleva las mejores especias indias en pequeños lotes, textiles tejidos a mano y joyería artesanal a hogares de toda Europa — sin los intermediarios que empobrecen la calidad y la historia.",
        "home.about.p2": "Cada masala se sella pocas horas después de molerse. Cada textil se estampa y borda en talleres que conocemos por su nombre. Cada joya se termina a mano. Somos exportador registrado DGFT, conforme a FSSAI y verificado por GST.",
        "home.about.cta": "Leer nuestra historia",
        "home.about.stat.products": "Productos seleccionados",
        "home.about.stat.houses": "Casas artesanas",
        "home.about.stat.est": "Fundada, Noida",
        "home.house.masalas": "La Casa de las Especias",
        "home.house.artificial-jewelry": "La Casa de la Joya",
        "home.house.home-furnishing": "La Casa del Textil",
        "home.house.christmas-decor": "La Casa de la Temporada",
        "home.shopAll": "Ver todo →",
        "home.viewAll": "Ver todo →",
        "home.testi.eyebrow": "Amado en toda Europa",
        "home.testi.title": "Lo que dicen nuestros clientes",
        "home.testi.q1": "El garam masala huele como si se hubiera molido esta mañana — prácticamente así fue. Nada en mi despensa se le acerca.",
        "home.testi.q2": "Nuestro camino de mesa Banarasi recibe un comentario en cada cena. La artesanía es verdaderamente de museo.",
        "home.testi.q3": "La gargantilla kundan llegó bellamente empaquetada y parece mucho más cara de lo que fue. Mi opción para regalar.",
        "cart.giftwrap.title": "Añadir envoltorio de regalo premium",
        "cart.giftwrap.desc": "Envuelto a mano en papel morera, con sello de cera dorado y flores secas.",
        "cart.giftwrap.note": "Mensaje de regalo (opcional)",
        "cart.giftwrap.notePlaceholder": "Escriba una breve nota a mano…",
        "cart.giftwrap.line": "Envoltorio de regalo",
        "xmas.banner": "Envío exprés gratuito en pedidos de Navidad superiores a 90 € — hasta el 24 de diciembre",
        "xmas.eyebrow": "La Edición Festiva",
        "xmas.title": "Una Navidad muy artesanal.",
        "xmas.subtitle": "Adornos de edición limitada, medias bordadas y mantelería festiva — hechos a mano en India, envueltos y enviados por toda Europa a tiempo para el árbol.",
        "xmas.cta": "Ver la colección",
        "xmas.guide.title": "La guía de regalos",
        "xmas.guide.sub": "Elegidos por nuestro taller — para cada nombre de su lista.",
        "xmas.guide.under": "Menos de 30 €",
        "xmas.guide.statement": "Regalos especiales",
        "xmas.guide.forHome": "Para el anfitrión",
        "xmas.shopAll": "Ver toda la Navidad →",
        "xmas.count.days": "días hasta Navidad",
        "xmas.count.today": "¡Feliz Navidad!",
        "xmas.count.orderby": "Pida antes del {d} para recibir a tiempo",
        "b2b.button": "Negocio / pedido al por mayor",
        "b2b.title": "Solicitar un pedido al por mayor / profesional",
        "b2b.sub": "Para pedidos al por mayor y de empresa. Deje sus datos y nuestro equipo de exportación le llamará con precios profesionales.",
        "b2b.name": "Su nombre",
        "b2b.phone": "Número de contacto",
        "b2b.qty": "Cantidad / unidades necesarias",
        "b2b.email": "Correo (opcional)",
        "b2b.message": "Mensaje (opcional)",
        "b2b.submit": "Solicitar llamada",
        "b2b.sending": "Enviando…",
        "b2b.success": "Solicitud recibida — nuestro equipo se pondrá en contacto pronto.",
    },
    it: {
        "nav.home": "Home",
        "nav.masalas": "Spezie Indiane",
        "nav.decor": "Arredamento",
        "nav.jewelry": "Bigiotteria",
        "nav.christmas": "Decori Natalizi",
        "nav.shop": "Shop",
        "nav.account": "Account",
        "nav.login": "Accedi",
        "nav.logout": "Esci",
        "nav.register": "Registrati",
        "nav.cart": "Carrello",
        "nav.admin": "Admin",
        "hero.eyebrow": "Fond. India · Export in Europa",
        "hero.title": "I lussi più discreti del mondo.",
        "hero.subtitle": "Spezie indiane in piccoli lotti, tessili artigianali e gioielli d'artigiano — spediti da Delhi.",
        "hero.cta": "Esplora la collezione",
        "hero.cta2": "La nostra storia",
        "sec.about.eyebrow": "— La Nostra Storia",
        "sec.about.title": "Da un atelier di Noida alle case europee.",
        "sec.about.p1": "Keneth Global Inc è nata come un progetto di famiglia — selezionare il meglio dei giardini di spezie, dei telai e delle botteghe artigiane dell'India, e portarlo, senza fretta, in Europa.",
        "sec.about.p2": "Lavoriamo direttamente con produttori e artigiani di sei stati indiani. Niente fabbriche, niente intermediari — solo piccoli lotti e collaborazioni eque.",
        "sec.about.cta": "Leggi la nostra storia",
        "sec.verticals.title": "Tre case. Una provenienza.",
        "sec.verticals.sub": "Ogni pezzo nasce in una piccola bottega o cucina di famiglia.",
        "vert.masalas.title": "La Casa delle Spezie",
        "vert.masalas.desc": "Tostate a mano, macinate a pietra, sigillate in poche ore.",
        "vert.decor.title": "Arredamento",
        "vert.decor.desc": "Tessili stampati a blocchi e ricamati a mano.",
        "vert.jewelry.title": "Bigiotteria",
        "vert.jewelry.desc": "Gioielli artigianali fatti a mano — kundan, meenakari, oro del tempio.",
        "vert.christmas.title": "Decori Natalizi",
        "vert.christmas.desc": "Ornamenti, tessili e allestimenti festivi fatti a mano — in arrivo questa stagione.",
        "sec.comingSoon": "In arrivo",
        "sec.category.viewAll": "Vedi tutto",
        "sec.featured.title": "In evidenza questa stagione",
        "sec.featured.sub": "Una selezione dalle tre case.",
        "sec.craft.title": "La via senza fretta",
        "sec.craft.p1": "Nulla nelle nostre botteghe si misura in minuti.",
        "sec.craft.p2": "Il risultato: un catalogo di novantuno prodotti.",
        "sec.press.title": "Visto su",
        "sec.newsletter.title": "Il dispaccio.",
        "sec.newsletter.sub": "Note stagionali. Mai più di due volte al mese.",
        "sec.newsletter.placeholder": "La tua email",
        "sec.newsletter.submit": "Iscriviti",
        "shop.title": "Lo shop",
        "shop.filter.all": "Tutto",
        "shop.filter.masalas": "Spezie Indiane",
        "shop.filter.decor": "Arredamento",
        "shop.filter.jewelry": "Bigiotteria",
        "shop.filter.christmas": "Decori Natalizi",
        "shop.empty": "Nessun prodotto trovato.",
        "shop.soon": "Questa collezione arriva presto. Torna a trovarci a breve.",
        "prod.addCart": "Aggiungi al carrello",
        "prod.buyNow": "Compra ora",
        "prod.details": "Dettagli",
        "prod.qty": "Quantità",
        "prod.related": "Potrebbe piacerti",
        "cart.title": "Il tuo carrello",
        "cart.empty": "Il carrello è vuoto.",
        "cart.item": "Articolo",
        "cart.qty": "Qtà",
        "cart.price": "Prezzo",
        "cart.total": "Totale",
        "cart.subtotal": "Subtotale",
        "cart.checkout": "Vai al checkout",
        "cart.continue": "Continua lo shopping",
        "cart.remove": "Rimuovi",
        "checkout.processing": "Preparazione…",
        "success.title": "Grazie.",
        "success.sub": "Il tuo ordine è stato ricevuto.",
        "success.orderId": "Riferimento",
        "success.viewOrders": "I miei ordini",
        "cancel.title": "Pagamento annullato",
        "cancel.sub": "Nessun addebito effettuato.",
        "cancel.back": "Torna al carrello",
        "auth.login.title": "Bentornato",
        "auth.login.sub": "Accedi.",
        "auth.register.title": "Crea un account",
        "auth.register.sub": "Per una corrispondenza più personale.",
        "auth.email": "Email",
        "auth.password": "Password",
        "auth.name": "Nome completo",
        "auth.signIn": "Accedi",
        "auth.signUp": "Crea",
        "auth.noAccount": "Non hai un account?",
        "auth.hasAccount": "Hai già un account?",
        "acct.title": "I tuoi ordini",
        "acct.sub": "Registro di ogni spedizione.",
        "acct.empty": "Nessun ordine.",
        "acct.orderId": "Ordine",
        "acct.date": "Effettuato il",
        "acct.status": "Stato",
        "acct.amount": "Importo",
        "acct.items": "Articoli",
        "admin.title": "Atelier — admin",
        "admin.stats": "In sintesi",
        "admin.products": "Prodotti",
        "admin.orders": "Ordini",
        "admin.users": "Clienti",
        "admin.revenue": "Ricavi",
        "footer.about": "Casa",
        "footer.about.about": "Chi siamo",
        "footer.about.craft": "Artigianalità",
        "footer.about.press": "Stampa",
        "footer.shop": "Shop",
        "footer.support": "Assistenza",
        "footer.support.contact": "Contatto",
        "footer.support.shipping": "Spedizione",
        "footer.support.returns": "Resi",
        "footer.legal": "© 2026 Keneth Global Inc. Tutti i diritti riservati.",
        "footer.tagline": "Il mondo a portata di clic, in ogni momento.",
        "common.loading": "Caricamento…",
        "badge.new": "Nuovo",
        "home.about.eyebrow": "Chi è Keneth Global",
        "home.about.title": "Una casa dell'artigianato indiano, portata sulla tua tavola.",
        "home.about.p1": "Fondata a Noida nel 2023, Keneth Global è una casa di export a conduzione familiare che porta le migliori spezie indiane in piccoli lotti, tessili tessuti a mano e gioielli artigianali nelle case di tutta Europa — senza gli intermediari che impoveriscono qualità e storia.",
        "home.about.p2": "Ogni masala è sigillato poche ore dopo la macinatura. Ogni tessile è stampato e ricamato da botteghe che conosciamo per nome. Ogni gioiello è rifinito a mano. Siamo un esportatore registrato DGFT, conforme FSSAI e verificato GST.",
        "home.about.cta": "Leggi la nostra storia",
        "home.about.stat.products": "Prodotti selezionati",
        "home.about.stat.houses": "Case artigiane",
        "home.about.stat.est": "Fondata, Noida",
        "home.house.masalas": "La Casa delle Spezie",
        "home.house.artificial-jewelry": "La Casa del Gioiello",
        "home.house.home-furnishing": "La Casa del Tessile",
        "home.house.christmas-decor": "La Casa della Stagione",
        "home.shopAll": "Vedi tutto →",
        "home.viewAll": "Vedi tutto →",
        "home.testi.eyebrow": "Amato in tutta Europa",
        "home.testi.title": "Cosa dicono i nostri clienti",
        "home.testi.q1": "Il garam masala profuma come se fosse stato macinato stamattina — di fatto lo era. Niente sul mio scaffale gli si avvicina.",
        "home.testi.q2": "Il nostro runner Banarasi riceve un complimento a ogni cena. La lavorazione è davvero da museo.",
        "home.testi.q3": "La collana kundan è arrivata splendidamente confezionata e sembra molto più costosa di quanto fosse. La mia scelta per i regali.",
        "cart.giftwrap.title": "Aggiungi confezione regalo premium",
        "cart.giftwrap.desc": "Avvolto a mano in carta di gelso, con sigillo in ceralacca dorata e fiori essiccati.",
        "cart.giftwrap.note": "Messaggio regalo (facoltativo)",
        "cart.giftwrap.notePlaceholder": "Scrivi un breve biglietto a mano…",
        "cart.giftwrap.line": "Confezione regalo",
        "xmas.banner": "Consegna espressa gratuita sugli ordini di Natale oltre 90 € — fino al 24 dicembre",
        "xmas.eyebrow": "La Selezione Festiva",
        "xmas.title": "Un Natale davvero artigianale.",
        "xmas.subtitle": "Ornamenti in edizione limitata, calze ricamate e tessili festivi per la tavola — fatti a mano in India, confezionati e spediti in tutta Europa in tempo per l'albero.",
        "xmas.cta": "Scopri la collezione",
        "xmas.guide.title": "La guida ai regali",
        "xmas.guide.sub": "Scelti dal nostro atelier — per ogni nome della tua lista.",
        "xmas.guide.under": "Sotto i 30 €",
        "xmas.guide.statement": "Regali d'eccezione",
        "xmas.guide.forHome": "Per il padrone di casa",
        "xmas.shopAll": "Vedi tutto Natale →",
        "xmas.count.days": "giorni a Natale",
        "xmas.count.today": "Buon Natale!",
        "xmas.count.orderby": "Ordina entro il {d} per la consegna in tempo",
        "b2b.button": "Azienda / ordine all'ingrosso",
        "b2b.title": "Richiedi un ordine all'ingrosso / commerciale",
        "b2b.sub": "Per ordini all'ingrosso e aziendali. Lascia i tuoi dati e il nostro ufficio export ti richiamerà con prezzi commerciali.",
        "b2b.name": "Il tuo nome",
        "b2b.phone": "Numero di contatto",
        "b2b.qty": "Quantità / unità richieste",
        "b2b.email": "Email (facoltativa)",
        "b2b.message": "Messaggio (facoltativo)",
        "b2b.submit": "Richiedi richiamo",
        "b2b.sending": "Invio…",
        "b2b.success": "Richiesta ricevuta — il nostro team ti contatterà a breve.",
    },
};

export const TRANSLATIONS = Object.fromEntries(Object.entries(BASE_TRANSLATIONS).map(([lang, entries]) => [lang, { ...entries, ...STOREFRONT_TRANSLATIONS[lang] }]));
